import React from "react";
import { Radio, Mic, Film, Shield, Target, Sparkles, Music, Headphones, Disc, Drum, Users, Heart } from "lucide-react";

const ICONS = { radio: Radio, mic: Mic, film: Film, shield: Shield, target: Target, sparkles: Sparkles, music: Music, headphones: Headphones, disc: Disc, drum: Drum, users: Users, heart: Heart };

export default function DynamicIcon({ name, className = "w-4 h-4", ...props }) {
  const Icon = ICONS[name] || Sparkles;
  return <Icon className={className} {...props} />;
}
